export const APP_STORE_URL = 'https://apps.apple.com/app/gym-journey-workout-tracker/id6478086571'
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.gymjourney'
export const DOWNLOAD_URL = 'https://www.gymjourney.fit/download'

export function getPlatform() {
  if (typeof navigator === 'undefined') return 'desktop'
  const ua = navigator.userAgent || ''
  if (/android/i.test(ua)) return 'android'
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios'
  // iPadOS reports a desktop Safari user agent
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios'
  return 'desktop'
}
